// @owners { team: patient-fulfillment }
import { type OrderPricingParams } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { type Order } from '~shared/features/checkout/types';

export const makeFetchOrderPricingOrderParam = ({
  items = [],
  selected_payment_types,
  tip_amount,
  address_id,
  date,
  deliver_after,
  deliver_before,
  on_demand_delivery_price,
}: Order): OrderPricingParams => {
  const param: OrderPricingParams = {
    items: items.map((item) => ({ ...item, selected_price_type: null })),
    selected_payment_types,
    tip_amount,
    scheduling_params: undefined,
    on_demand_delivery_price,
  };
  if (date && address_id) {
    param.scheduling_params = {
      address_id,
      date,
      deliver_after,
      deliver_before,
    };
  }
  return param;
};
